<template>
  <div class="footer-join">
    <div class="container">
      <el-row>
        <el-col
          :xl="24"
          :lg="24"
          :md="24"
          :sm="24"
          :xs="24"
          class="head"
        >
          <h1 class="text-white footer-text">
            {{ footerText.heading }}
          </h1>
        </el-col>
        <a
          :href="contactUsUrl"
          class="button-link"
          target="_blank"
        >
          <el-button
            class="join-btn-bottom"
            type="primary"
          >Email the team</el-button>
        </a>
        <!-- <p class="text-white footer-text">Or call <a class="call-link mx-2" href="tel:+441412282990">+44(0)141 228 2990</a> (Mon - Fri 8:30am to 5:30pm)</p> -->
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      footerText: {
        heading: "Need to get in touch with the Community Wealth Builder Team?",
      }
    };
  },
  computed:{
    contactUsUrl(){
      return `${process.env.VUE_APP_BE_WELL_CMS_URL}/for-my-organisation/contact-us-cwb`
    }
  }
};
</script>
<style lang="scss">
.footer-join {
  .button-link {
    text-decoration: unset;
  }
  .footer-text {
    text-align: center;
    margin-top: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
    a {
      text-decoration: underline;
      color: white;
    }
  }
  h1 {
    font-family: $font-coheadline-bold;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 2.313rem;
    margin-bottom: 20px;
  }

  .join-btn-bottom {
    margin: auto;
  }
  .give-feedback p {
    color: white;
    margin-left: 10px;
    text-decoration: underline;
  }
  .give-feedback {
    text-align: center;
    padding-top: 45px;
  }
}
</style>
